<header class="header" [ngClass]="{ colored: isColored(['how-it-works']) }">
  <div class="container">
    <div class="header__wrapper">
      <div class="header__nav">
        <a class="header__link" [routerLink]="headerLink">
          <img
            class="header__brand"
            [ngClass]="{ 'header__brand--white': isColored(['how-it-works']) }"
            [src]="logoSrc"
            [alt]="'GLOBAL.app_name' | translate"
          />
        </a>
        <ng-container *ngFor="let menuItem of menuItems">
          <a
            *ngIf="menuItem.routerLink; else externalLink"
            class="header__link"
            [ngClass]="{ is__active: isActive(menuItem.routerLink) }"
            [routerLink]="menuItem.routerLink"
            >{{ menuItem.title | translate }}</a
          >
          <ng-template #externalLink>
            <a
              class="header__link"
              [ngClass]="{ is__active: isActive(menuItem.routerLink) }"
              [href]="menuItem.outgoingLink"
              target="_blank"
              >{{ menuItem.title | translate }}</a
            >
          </ng-template>
        </ng-container>
      </div>
      <div class="header__actions">
        <div class="header__actions" *ngIf="storage.user">
          <ng-container *ngIf="ukraineUrl">
            <button
              class="btn btn--outline btn--primary btn--sm"
              [ngClass]="{ 'btn--white': isColored([RoutesPath.default.how_it_works]) }"
              [routerLink]="['/help-ukraine-request/create']"
            >
              {{ 'HEADER.LINKS.create_ua_help' | translate }}
            </button>
          </ng-container>

          <ng-container *ngIf="!ukraineUrl">
            <button
              class="btn btn--outline btn--primary btn--sm"
              [ngClass]="{ 'btn--white': isColored([RoutesPath.default.how_it_works]) }"
              [routerLink]="['/' + RoutesPath.default.event_create]"
            >
              {{ 'HEADER.LINKS.create_event' | translate }}
            </button>
            <button
              class="btn btn--outline btn--primary btn--sm"
              [ngClass]="{ 'btn--white': isColored([RoutesPath.default.how_it_works]) }"
              [routerLink]="['/' + RoutesPath.default.project_create]"
            >
              {{ 'HEADER.LINKS.create_project' | translate }}
            </button>
          </ng-container>

          <app-ph-drop position="bottom right" #dropNotification classes="notification-drop">
            <div class="target">
              <button class="btn btn--link btn--lg btn--32">
                <img
                  class="btn__icon"
                  [ngClass]="{ white: isColored(['how-it-works']) }"
                  src="assets/img/icons/notification.svg"
                  [alt]="'HEADER.LINKS.notifications' | translate"
                />
                <span class="header__items" *ngIf="notificationsUnseen > 0">{{
                  notificationsUnseen ? notificationsUnseen : null
                }}</span>
              </button>
            </div>
            <div class="content">
              <app-notifications-dropdown
                (closeNotificationEmitter)="onCloseNotifications()"
              ></app-notifications-dropdown>
            </div>
          </app-ph-drop>
          <div class="btn btn--avatar btn--lg btn--44">
            <app-ph-avatar
              [username]="
                storage.user.sign_project_by_name
                  ? storage.setAvatarInitials(storage.user.display_name, '')
                  : storage.setAvatarInitials(storage.user.name, storage.user.surname)
              "
              [src]="storage.user.avatar_image"
              [isWhite]="isColored(['how-it-works'])"
              (click)="onAvatarClick()"
            ></app-ph-avatar>
            <div class="dropdown dropdown--default">
              <ul class="list list--dropdown">
                <li class="dropdown__item">
                  <a class="dropdown__link" [routerLink]="['/' + RoutesPath.default.wallet]">{{
                    'HEADER.LINKS.wallet' | translate
                  }}</a>
                </li>
                <li class="dropdown__item">
                  <a
                    class="dropdown__link"
                    [routerLink]="[
                      '/' +
                        RoutesPath.default.profile +
                        '/' +
                        storage.user.id +
                        '/' +
                        RoutesPath.default.profileTabs.summary
                    ]"
                    >{{ 'HEADER.LINKS.my_profile' | translate }}</a
                  >
                </li>
                <li class="dropdown__item">
                  <a class="dropdown__link" [routerLink]="['/' + RoutesPath.default.account]">{{
                    'HEADER.LINKS.account_settings' | translate
                  }}</a>
                </li>
                <li class="dropdown__item">
                  <span class="dropdown__separator"></span>
                </li>
                <li class="dropdown__item">
                  <button class="btn dropdown__button text--danger" (click)="storage.logout()">
                    {{ 'AUTH.sign_out' | translate }}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="header__actions" *ngIf="!storage.user">
          <ng-container *ngIf="ukraineUrl">
            <a
              class="btn btn--primary btn--sm"
              [ngClass]="{ 'btn--outline btn--white': isColored(['how-it-works']) }"
              [routerLink]="[]"
              [queryParams]="authPage('login')"
              >{{ 'HELPUKRAINE_PAGE.help_ukraine' | translate }}</a
            >
          </ng-container>
          <a
            class="btn btn--link btn--lg btn--dark btn--log-in"
            [ngClass]="{ white: isColored(['how-it-works']) }"
            [routerLink]="[]"
            [queryParams]="authPage('login')"
            >{{ 'AUTH.sign_in' | translate }}</a
          >
          <app-lang-switcher [isWhite]="isColored(['how-it-works'])"></app-lang-switcher>
        </div>
        <div class="header__actions__socials">
          <div class="header__actions__socials__wrapper">
            <div class="header__actions__socials--single">
              <a target="_blank" [href]="facebookLink">
                <img
                  [src]="'assets/img/icons/facebook-white.webp'"
                  alt="Facebook"
                  [ngClass]="{
                    grey: !isColored(['how-it-works']),
                    white: isColored(['how-it-works'])
                  }"
                />
              </a>
            </div>
            <div class="header__actions__socials--single">
              <a target="_blank" [href]="instagramLink">
                <img
                  src="assets/img/icons/instagram-logo-color.webp"
                  alt="Instagram"
                  [ngClass]="{
                    grey: !isColored(['how-it-works']),
                    white: isColored(['how-it-works'])
                  }"
                />
              </a>
            </div>
            <div class="header__flag">
              <a href="assets/docs/PMT.pdf" target="_blank">
                <img class="header__brand" src="assets/img/EU_logo.svg" alt="EU" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
